var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "conversion-block" },
    [
      _c(_vm.campaign, {
        tag: "component",
        attrs: { colorMode: _vm.colorMode },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }